module.exports = __webpack_public_path__ + "static/media/preview_chart_2_Views.2c89dc74.PNG";